import axios from "axios";

async function getBookings(from?: string, until?: string) {
    const res = await axios.get(
        `/bookings${from ? `?from=${from}&until=${until}` : ""}`
    );
    return res.data;
}

async function getBooking(bookingId: number) {
    const res = await axios.get(`/bookings/${bookingId}`);
    return res.data;
}

// async function getSanctions(closed: string, from?: string, until?: string) {
//     let query = from ? `&from=${from}&until=${until}` : "";
//     const res = await axios.get(`sanctions?closed=${closed}${query}`);
//     return res.data;
// }


export const MoutebeApi = {
    getBookings,
    getBooking,
    // getSanctions
};
